import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-095fac2c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "provide"
};
import { computed, provide } from 'vue';
import { Unique } from '@/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigProvider',
  props: {
    question: {
      "default": {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    provide(Unique, {
      question: computed(function () {
        return props.question;
      })
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")]);
    };
  }
});